import React, { useCallback, useContext } from 'react'
import { Modal, Button } from '@themesberg/react-bootstrap'
import { Context } from '..'

const _Popup = () => {

  const { state, dispatch } = useContext(Context);

  const handleClose = useCallback(() => {
    dispatch({
      type: 'CLOSE_ZNS_POPUP',
      payload: false,
    })
  }, [])

  const handleConfirm = useCallback(() => {
    dispatch({
      type: 'CLOSE_ZNS_POPUP',
      payload: true,
    })
  }, [])

  return (
    <Modal as={Modal.Dialog} centered show={state.znsPopup.show} onHide={(handleClose)}>
      <Modal.Header>
        <Modal.Title className="h6">Xác nhận</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        {state.znsPopup.content}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" className="text-gray" onClick={handleClose}>
          Không
        </Button>
        <Button variant="secondary" className="ms-auto" onClick={handleConfirm}>
          Có
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(_Popup)